/**
 * Risks Block Configuration
 *
 * Registry config for the risks/hazards block type.
 */

import { AlertTriangle } from "lucide-react";
import { RisksBlock } from "@/canvas/components/blocks/RisksBlock";
import type { BlockConfig } from "../types";

export const risksBlockConfig: BlockConfig<"risks"> = {
  type: "risks",
  component: RisksBlock,
  icon: AlertTriangle,
  iconClassName: "text-amber-500",
  label: "canvas.blockTypes.risks",
  defaultContent: () => ({ items: [] }),
  showInAddBlockMenu: true,
};
